import * as React from "react";

import { StyledLink } from "./Link";
import {
  BREAK_POINTS,
  ButtonPrimaryRedSkin
} from "@origin-digital/style-guide";

export const ButtonSmall = ButtonPrimaryRedSkin.extend`
  @media only screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 12px 24px;
    font-size: 14px;
  }
`;

interface Props {
  onClick?: (e?: any) => void | boolean;
  href?: string;
  children: React.ReactNode;
  tracking?: string;
  small?: boolean;
}

export const ButtonAction: React.StatelessComponent<Props> = ({
  href,
  onClick,
  children,
  tracking,
  small
}) => {
  const button = small ? (
    <ButtonSmall>{children}</ButtonSmall>
  ) : (
    <ButtonPrimaryRedSkin>{children}</ButtonPrimaryRedSkin>
  );

  return (
    <StyledLink
      href={href}
      onClick={onClick}
      data-id={tracking}
      componentType={"button"}
    >
      {button}
    </StyledLink>
  );
};
